import type { Role } from '../types';
import type { Actor } from './auditService';

// Who is signed in and which clinic they're working in. Set by AppProvider; read by
// services so screens don't have to pass the clinic id into every call.
interface Scope {
  facilityId: string;
  role: Role;
  uid: string | null;
  actor?: Actor;
}

let current: Scope = { facilityId: '', role: 'staff', uid: null };

export function setDataScope(s: Partial<Scope>) {
  current = { ...current, ...s };
}

export function scope(): Scope {
  return current;
}
